module.exports = __webpack_public_path__ + "static/media/bannerplaceholder.6f220280.svg";